export const triggers_index = ['triggers.index']
export const triggers_create = ['triggers.create']
export const triggers_edit = ['triggers.edit']

export default [].concat(
    triggers_index,
    triggers_create,
    triggers_edit
)
